'use client';

/**
 * SysObeyaKpiFeaturesCard — feature-scope KPI tile.
 *
 * Slices `response.totals.{total_fp, total_features}` from the
 * system_obeya_view composite. Chrome (label, unit) comes from
 * `response.labels`. One of four tiles that replace the legacy
 * monolithic SysObeyaKpiStripCard.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_features"
 * @see klyde_edge/ui_config/labels/system_obeya.py — mod_sum_kpi_features_*
 */

import { Sparkles } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiFeaturesCard({ view_name = 'module_summary' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_features"
      label={L.mod_sum_kpi_features_label ?? ''}
      Icon={Sparkles}
      value={isLoading ? '…' : fmt(t.total_fp)}
      sub={`${fmt(t.total_features)} ${L.mod_sum_kpi_features_unit ?? ''}`.trim()}
      queryKey={queryKey}
    />
  );
}
